/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_New_List_TitleInputs */

const en_markers_new_list_title = /** @type {(inputs: Markers_New_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Marker List`)
};

const fr_markers_new_list_title = /** @type {(inputs: Markers_New_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle liste de marqueurs`)
};

const de_markers_new_list_title = /** @type {(inputs: Markers_New_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Markerliste`)
};

const it_markers_new_list_title = /** @type {(inputs: Markers_New_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo elenco marcatori`)
};

const ru_markers_new_list_title = /** @type {(inputs: Markers_New_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новый список маркеров`)
};

const es_markers_new_list_title = /** @type {(inputs: Markers_New_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva lista de marcadores`)
};

const zh_cn2_markers_new_list_title = /** @type {(inputs: Markers_New_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新标记列表`)
};

const ja_markers_new_list_title = /** @type {(inputs: Markers_New_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいマーカーリスト`)
};

const hi_markers_new_list_title = /** @type {(inputs: Markers_New_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नई मार्कर सूची`)
};

const pt_pt2_markers_new_list_title = /** @type {(inputs: Markers_New_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova lista de marcadores`)
};

/**
* | output |
* | --- |
* | "New Marker List" |
*
* @param {Markers_New_List_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_new_list_title = /** @type {((inputs?: Markers_New_List_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_New_List_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_new_list_title(inputs)
	if (locale === "de") return de_markers_new_list_title(inputs)
	if (locale === "it") return it_markers_new_list_title(inputs)
	if (locale === "ru") return ru_markers_new_list_title(inputs)
	if (locale === "es") return es_markers_new_list_title(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_new_list_title(inputs)
	if (locale === "ja") return ja_markers_new_list_title(inputs)
	if (locale === "hi") return hi_markers_new_list_title(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_new_list_title(inputs)
	return en_markers_new_list_title(inputs)
});